import React from "react";
import { SectionCta } from "../SectionCta";
import { images } from "../../data/content";
export function Author() {
  return <section className="bg-white px-4 py-16 sm:px-6 sm:py-24" aria-labelledby="author-title" data-id="element-62" data-mp="1ht3thgky4c62">
      <div className="mx-auto grid max-w-5xl items-center gap-10 md:grid-cols-[minmax(0,380px)_1fr] md:gap-14" data-id="element-63" data-mp="1whgoaa8aroyz">
        <div className="relative mx-auto w-full max-w-sm" data-id="element-64" data-mp="1rodqfpwhltcz">
          <div className="overflow-hidden rounded-[28px] bg-cream ring-1 ring-navy-900/10" data-id="element-65" data-mp="25gk9bjr0yeg4">
            <img src={images.author} alt="Dr. Valeria Montes in her dental clinic" className="aspect-[4/5] w-full object-cover object-top" data-id="element-66" data-mp="20is7ny0kvdyq" />
          </div>
          <div className="absolute -bottom-5 left-1/2 w-[85%] -translate-x-1/2 rounded-2xl bg-navy-900 px-4 py-3 text-center text-white shadow-lg" data-id="element-67" data-mp="2fdgk5w4ebcnu">
            <p className="font-display text-lg font-black" data-id="element-68" data-mp="l0qe6g0r6d03">Dr. Valeria Montes</p>
            <p className="text-xs font-medium text-gold-400" data-id="element-69" data-mp="g2oubsvi69nk">Author · Mandibular Complete Denture Blueprint™</p>
          </div>
        </div>

        <div className="pt-4 md:pt-0" data-id="element-70" data-mp="3gfnqnfqxzas6">
          <p className="text-sm font-bold uppercase tracking-wide text-brand" data-id="element-71" data-mp="3gcjhe3ymdoun">Meet your author</p>
          <h2 id="author-title" className="mt-3 font-display text-[26px] font-black leading-tight text-ink sm:text-4xl" data-id="element-72" data-mp="3kdlh0lwg82x5">
            “Clinical confidence begins with understanding what you're evaluating — and why.”
          </h2>
          <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-muted" data-id="element-73" data-mp="2zzll40b5lt8">
            <p data-id="element-74" data-mp="7yauncis3sae">
              When you're working with a challenging mandibular denture case, the amount of information you need to
              consider can feel overwhelming. Anatomy, tissue conditions, functional movements, impression techniques,
              occlusal relationships, and patient expectations all influence your clinical reasoning.
            </p>
            <p data-id="element-75" data-mp="2dtlxwa28z6yg">
              That's why this resource is organized around one central idea:{" "}
              <strong className="text-ink" data-id="element-76" data-mp="2isos0zgovsrn">a clear assessment process helps you make more informed clinical decisions.</strong>
            </p>
            <p data-id="element-77" data-mp="3h2yf0kpnrrwv">
              Inside, you'll find educational references, structured worksheets, and visual decision tools intended to
              make complex concepts easier to review and apply within your professional scope.
            </p>
            <p data-id="element-78" data-mp="3q1s7pzzvby55">
              My goal is to help you approach mandibular complete denture cases with a more organized understanding of
              the factors that deserve attention.
            </p>
          </div>
          <p className="mt-6 font-display text-xl font-black italic text-navy-800" data-id="element-79" data-mp="3tsmqwbqy44h">— Dr. Valeria Montes</p>
        </div>
      </div>

      <SectionCta label="Yes! I want Dr. Montes' clinical blueprint" data-id="element-80" data-mp="dl6gsokxibq8" />
    </section>;
}